import React, { useState } from "react";
import api from "../utils/axiosConfig";
import { useNavigate } from "react-router-dom";
import img from "../assets/akar-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const API_URL = process.env.REACT_APP_API_URL;

const UpdateLogin = () => {
  const [email, setEmail] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  // separate toggles (better UX)
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);

  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleClick = () => navigate("/");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const response = await api.put(`${API_URL}/auth/update-password`, {
        email,
        currentPassword,
        newPassword,
      });

      console.log("Update success:", response.data.message);
      navigate("/");
    } catch (error) {
      const msg =
        error?.response?.data?.message || "Update failed. Please try again.";
      setError(msg);
      console.error("Update failed:", msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img src={img} className="login-logo" alt="Akar Logo" />
        <h1 className="login-title">Update Password</h1>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-input-group">
            <input
              type="email"
              placeholder="Enter Registered Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input"
              required
              disabled={isLoading}
            />
          </div>

          <div className="login-input-group password-input-wrapper">
            <input
              type={showCurrent ? "text" : "password"}
              placeholder="Current Password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="login-input"
              required
              disabled={isLoading}
            />
            <div
              className="password-toggle-icon"
              onClick={() => setShowCurrent((v) => !v)}
              role="button"
              tabIndex={0}
            >
              <FontAwesomeIcon icon={showCurrent ? faEye : faEyeSlash} />
            </div>
          </div>

          <div className="login-input-group password-input-wrapper">
            <input
              type={showNew ? "text" : "password"}
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="login-input"
              required
              disabled={isLoading}
            />
            <div
              className="password-toggle-icon"
              onClick={() => setShowNew((v) => !v)}
              role="button"
              tabIndex={0}
            >
              <FontAwesomeIcon icon={showNew ? faEye : faEyeSlash} />
            </div>
          </div>

          {error && <p className="login-error">{error}</p>}

          <button
            type="submit"
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? "Updating..." : "Update Password"}
          </button>
        </form>

        <button
          onClick={handleClick}
          className="login-secondary-button"
          disabled={isLoading}
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default UpdateLogin;
